"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uris_1 = require("../globals/uris");
/**
 * A control actively changes its value.
 */
class Control {
    constructor(uri, name, type, store) {
        this.uri = uri;
        this.name = name;
        this.type = type;
        this.store = store;
        this.store.addValueObserver(this.uri, uris_1.VALUE, this);
    }
    getName() {
        return this.name;
    }
    getUri() {
        return this.uri;
    }
    getValue() {
        return this.value;
    }
    getType() {
        return this.type;
    }
    updateValue(newValue) {
        if (!isNaN(newValue)) {
            this.setValue(newValue);
        }
    }
    resetValue() {
        this.value = undefined;
        this.store.setValue(this.uri, uris_1.VALUE, null);
    }
    setValue(newValue) {
        if (this.value == undefined || Math.abs(newValue - this.value) > 0.000001) { //deal with floating point errors
            this.value = newValue;
            this.store.setValue(this.uri, uris_1.VALUE, newValue);
            return true;
        }
    }
    observedValueChanged(uri, type, value) {
        if (uri === this.uri) {
            this.setValue(value);
        }
    }
}
exports.Control = Control;



//////////////////
// WEBPACK FOOTER
// ./~/dymo-core/lib/model/control.js
// module id = 412
// module chunks = 3